<template>
  <div class="max-w-lg mx-auto">
    <h1 class="mb-2">Order a cake</h1> 
    <div class="mb-8 text-sm px-2" v-html="compiledMarkdown"></div>
    <template v-if="!hideGroups">
      <CakeGroupChoice v-model="group" :groups="groups" />
    </template>
  <div id="box"></div>
  <CakeProductChoice :group="group" v-model="sku" v-if="group" />
  <div id="colours">
    <CakeColourPicker v-model="colour" :group="group" v-if="showColour" />
  </div>

  <div id="flavours"></div>
  <CakeFlavourPicker v-model="flavour" :sku="sku" :flavours="chosenGroup.flavours" v-if="showFlavours" />

  <div id="message"></div>
  <section class="px-4" v-if="showMessage">

    <framed-image :images="[$root.$data.images.cake_message]" />
    <h2>Would you like a message or number on the cake?</h2>
    <input type="text" class="input text-center" maxlength="40" placeholder="Enter your message or number here" v-model="message" />
  </section>

  <section class="px-4" v-if="showTopperWarning">
    <h2>Toppers</h2>
    <p class="text-sm">Toppers shown aren't included in the price, but can be easily added. Prices start from £5. Let us know what you'd like in the "Additional Comments" box during checkout.</p>
  </section>
  <section class="px-4" v-if="showTopperIncluded">
    <h2>Toppers</h2>
    <p class="text-sm">Toppers shown are included in the price. Yay!</p>
  </section>

  <div v-if="showSummary" class="px-4">
    <cake-item-summary :sku="sku" :chosenFlavour="flavour" :message="message" :colour="colour" />
    <button @click.prevent="addToBasket"
      class="bg-jblue py-4 px-4 block w-full uppercase font-proxima text-white">
      {{id ? "Update order" : `Add to basket`}}
    </button>
  </div>
  </div>
</template>

<script>

import { find, remove } from 'lodash'

import marked from 'marked';
import FramedImage from '../components/FramedImage'
import CakeGroupChoice from '../components/CakeGroupChoice';
import CakeProductChoice from '../components/CakeProductChoice';
import CakeFlavourPicker from '../components/CakeFlavourPicker';
import CakeColourPicker from '../components/CakeColourPicker';
import CakeItemSummary from '../components/CakeItemSummary';
import lscache from 'lscache';

export default {
  props: {
    value: {}, 
    defaultGroups: {}
  },
  data() {
    return {
      group: null,
      sku: null,
      id: null,
      message: null,
      flavour: null,
      colour: null,
      groups: this.defaultGroups
    }
  },
  components: {
    CakeGroupChoice,
    CakeProductChoice,
    CakeFlavourPicker,
    CakeItemSummary,
    CakeColourPicker,
    FramedImage
  },
  methods: {
    addToBasket() {
      let basket = []
      if(lscache.get('basket')) {
        try {
          basket = lscache.get('basket')
          if(!basket) {
            basket = []
          }
        } catch(e) {
          basket = []
        }
      }

      if(this.id) {
        remove(basket, {id: this.id})
      } else {

        const product = find(this.$root.$data.products, {sku: this.sku})
        window.gtag('event','add_to_cart', {
          currency: "GBP",
          items: [{
            id: product.sku,
            quantity: 1,
            price: product.amount,
            name: product.name
          }]
        })
      }

      basket.push({
        sku: this.sku,
        flavours: [this.flavour],
        message: this.message,
        cake: true,
        colour: this.colour,
        id: this.id ? this.id : new Date().getTime().toString()
      })

      lscache.set('basket', basket, 60 * 24 * 3)

      this.$router.push({name: 'basket'})

    }
  },
  computed: {

    compiledMarkdown() {
      if(this.group == 'christmas-swirl' || this.group == 'christmas-ganache') {
        return marked(this.$root.$data.images.cake_intro_special)
      } else {
        return marked(this.$root.$data.images.cake_intro)
      }
    },
    hideGroups() {
      return this.groups && this.groups.length == 1
    },
    chosenGroup() {
      return find(this.$root.$data.groups, {id: this.group})
    },
    hasColours() {
      return this.chosenGroup && this.chosenGroup.colours
    },
    showColour() {
      return this.sku && this.hasColours
    },
    showTopperWarning() {
      return this.chosenGroup && this.chosenGroup.topperWarning
    },
    showTopperIncluded() {
      return this.group && ["dino","mermaid"].includes(this.group)
    },
    showFlavours() {
      if(this.hasColours) {
        return this.sku && this.group && this.colour
      } else {
        return this.sku && this.group
      }
    },
    showMessage() {
      return this.showFlavours && this.flavour && this.chosenGroup.message
    },
    showSummary() {
      return this.showFlavours && this.flavour
    }
  },
  mounted() {

    if(this.groups && this.groups.length == 1) {
      this.group = this.groups[0]
    }

    if(this.$router.currentRoute.name == "edit-cake") {
      const basket = lscache.get('basket')
      const item = find(basket, {id: this.$router.currentRoute.params.id})
      const product = find(this.$root.$data.products, {sku: item.sku})

      this.group = product.group


      if(product.group.includes("christmas-swirl") || product.group.includes("christmas-ganache")) {
        this.groups = ['christmas-swirl','christmas-ganache']
      }

      this.sku = product.sku
      this.message = item.message
      this.colour = item.colour
      if(item.flavours.length) {
        this.flavour = item.flavours[0]
      }
      this.id = item.id
    }
  },
  watch: {
    group(newItem, oldItem) {
      if(oldItem) {
        this.sku = null
        this.colour = null
      }
    }
  },
  head: {
    title() {
      return {
        inner: "Cakes"
      }
    }
  }
}
</script>
